import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { isEmpty } from "lodash"

import InputField from "components/input"
import SubmitNotification from "components/common/submit-notification"
import Button from "components/common/Button"

import {
  submitForumQuestion,
  updateForumQuestion,
  closeForumModal,
} from "store/school/actions"

export class QuestionForm extends Component {
  constructor() {
    super()

    this.state = {
      questionForm: {
        title: "",
        description: "",
        tags: "",
      },
      questionId: null,
      fieldErrors: {},
    }
  }

  componentDidMount() {
    const {
      school: {
        forumModal: { isEdit = false },
        questionData = {},
      },
    } = this.props

    if (isEdit) {
      this.setState({
        questionForm: {
          title: questionData.title,
          description: questionData.description,
          tags: (questionData.tags || []).join(", "),
        },
        questionId: questionData.id,
      })
    }
  }

  componentDidUpdate(prevProps) {
    const {
      school: { errors },
    } = this.props

    const {
      school: { errors: prevErrors },
    } = prevProps

    if (errors !== prevErrors) {
      this.setState({ fieldErrors: errors })
    }
  }

  handleChange = (e) => {
    const { questionForm } = this.state
    const { name, value } = e.currentTarget
    this.setState(
      {
        questionForm: {
          ...questionForm,
          [name]: value,
        },
      },
      () => {
        this.validateField(name)
      }
    )
  }

  validateField = (fieldName) => {
    const { fieldErrors, questionForm } = this.state

    if (fieldName === "tags") {
      return
    }

    if (isEmpty(questionForm[fieldName])) {
      fieldErrors[fieldName] = "This field is required"
    } else {
      delete fieldErrors[fieldName]
    }
    this.setState({ fieldErrors })
  }

  onSubmit = () => {
    const {
      school: {
        schoolData = {},
        forumModal: { isEdit = false },
      },
      submitForumQuestion,
      updateForumQuestion,
    } = this.props
    const {
      questionForm = {},
      questionId = null,
      fieldErrors = {},
    } = this.state

    if (isEmpty(fieldErrors)) {
      let tags = questionForm.tags !== "" ? questionForm.tags.split(",") : []

      let payload = {
        ...questionForm,
        tags: tags.map((tag) => tag.trim()),
        school: schoolData.id,
      }

      if (isEdit && questionId) {
        updateForumQuestion(questionId, payload)
      } else {
        submitForumQuestion(payload)
      }
    }
  }

  render() {
    const {
      school: {
        forumModal: { errors },
      },
      closeForumModal,
    } = this.props

    const { questionForm = {}, fieldErrors = {} } = this.state

    return (
      <>
        <SubmitNotification
          type={errors && errors.non_field_errors && "FAILED"}
          message={errors && errors.non_field_errors}
        />
        <InputField
          label="Title"
          name="title"
          required={true}
          value={questionForm["title"]}
          error={fieldErrors["title"]}
          onChange={this.handleChange}
        />
        <InputField
          label="Description"
          name="description"
          type="textarea"
          required={true}
          value={questionForm["description"]}
          error={fieldErrors["description"]}
          onChange={this.handleChange}
        />

        <InputField
          label="Tags"
          name="tags"
          caption="A comma-separated list of tags."
          value={questionForm["tags"]}
          error={fieldErrors["tags"]}
          onChange={this.handleChange}
        />
        <div className="button-group">
          <Button
            label="Cancel"
            ghost={true}
            customClassName="mr-m"
            onClick={closeForumModal}
          />
          <Button label="Submit" onClick={this.onSubmit} />
        </div>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      submitForumQuestion,
      updateForumQuestion,
      closeForumModal,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  QuestionForm
)
